import { render, staticRenderFns } from "./criticismQuestion.vue?vue&type=template&id=08652124&"
import script from "./criticismQuestion.vue?vue&type=script&lang=js&"
export * from "./criticismQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports